import React, { useEffect, useState, useRef } from "react";
import { Button } from 'primereact/button';
import ClienteDetalleModal from './ClienteDetalleModal';
import { OrderList } from 'primereact/orderlist';
import { InputText } from "primereact/inputtext";
import Loader from "../components/Loader.js";
import { Tag } from 'primereact/tag';
import { Tooltip } from 'primereact/tooltip';

function OrderTableListaEspera({ header, listaEspera, loading, handleEditListaEspera, handleConvertListaEspera, handleDeleteListaEspera, handleReorderPrioridad, handleWhatsappListaEspera }) {
    const [showClienteModal, setShowClienteModal] = useState(false);
    const [clienteSeleccionado, setClienteSeleccionado] = useState(null);

    const openClienteModal = (rowData) => {
        setClienteSeleccionado(rowData?.cliente || null);
        setShowClienteModal(true);
    };

    const closeClienteModal = () => {
        setShowClienteModal(false);
        setClienteSeleccionado(null);
    };

    // Filtro OrderList
    const [filterValue, setFilterValue] = useState('');
    const filterInputRef = useRef();

    // Selección y orden del OrderList
    const [selectedItems, setSelectedItems] = useState([]);

    // Asegura que siempre se mapee sobre un arreglo
    const enrichItems = (arr) => (Array.isArray(arr) ? arr : []).map((row) => {
        const tiposDescripcion = Array.isArray(row.tipos_producto)
            ? row.tipos_producto.map((t) => t.descripcion).join(", ")
            : (row.tipo_producto?.descripcion || "");
        const filterText = [
            row?.cliente?.razon_social,
            row?.estado,
            row?.observaciones,
            String(row?.metraje_requerido || ""),
            tiposDescripcion
        ].filter(Boolean).join(" ");
        return { ...row, _tiposDescripcion: tiposDescripcion, _filterText: filterText };
    });

    const [items, setItems] = useState(
        enrichItems(
            Array.isArray(listaEspera)
                ? [...listaEspera].sort((a, b) => (Number(a?.prioridad ?? Infinity)) - (Number(b?.prioridad ?? Infinity)))
                : []
        )
    );

    useEffect(() => {
        // Si listaEspera no es arreglo, resetea items
        if (!Array.isArray(listaEspera)) {
            setItems([]);
            return;
        }
        // ordenar por prioridad al actualizar la lista
        const ordenada = [...listaEspera].sort((a, b) => (Number(a?.prioridad ?? Infinity)) - (Number(b?.prioridad ?? Infinity)));
        setItems(enrichItems(ordenada));
    }, [listaEspera]);

    const myResetFunction = (options) => {
        setFilterValue('');
        options.reset();
        filterInputRef && filterInputRef.current && filterInputRef.current.focus();
    };

    const myFilterFunction = (event, options) => {
        const _filterValue = event.target.value;
        setFilterValue(_filterValue);
        options.filter(event);
    };

    const filterTemplate = (options) => {
        const { filterOptions } = options;
        return (
            <div className="flex gap-2">
                <InputText
                    value={filterValue}
                    ref={filterInputRef}
                    placeholder="Filtrar por cliente..."
                    onChange={(e) => myFilterFunction(e, filterOptions)}
                    className="w-14rem"
                />
                {filterValue?.trim().length > 0 && (
                    <Button
                        icon="pi pi-filter-slash"
                        onClick={() => myResetFunction(filterOptions)}
                        className="p-button-outlined p-button-rounded"
                    />
                )}
            </div>
        );
    };

    // Mapeo de estados a colores/labels
    const mapEstadoToTag = (estadoRaw) => {
        const e = (estadoRaw || '').toString().trim().toUpperCase();
        if (['ESPERA'].includes(e)) {
            return { label: 'ESPERA', severity: 'warning' };
        }
        if (['NOTIFICADO'].includes(e)) {
            return { label: 'NOTIFICADO', severity: 'info' };
        }
        if (['CONVERTIDA'].includes(e)) {
            return { label: 'CONVERTIDA', severity: 'success' };
        }
        if (['CANCELADA'].includes(e)) {
            return { label: 'CANCELADA', severity: 'danger' };
        }
        if (['EXPIRADA'].includes(e)) {
            return { label: 'EXPIRADA', severity: null, style: { backgroundColor: '#6c757d', color: '#fff', borderRadius: '12px' } };
        }
        return { label: estadoRaw || '-', severity: null, style: { backgroundColor: '#e0e0e0', color: '#333', borderRadius: '12px' } };
    };

    const itemTemplate = (item) => {
        return (
            <div className="flex flex-column w-full">
                <div className="flex align-items-center justify-content-between">
                    <Button
                        className="p-button-link p-0"
                        label={item?.cliente?.razon_social || "Sin razón social"}
                        onPointerDown={(e) => e.stopPropagation()}
                        onMouseDown={(e) => e.stopPropagation()}
                        onDragStart={(e) => { e.preventDefault(); e.stopPropagation(); }}
                        onClick={(e) => { e.stopPropagation(); openClienteModal(item); }}
                        tooltip="Ver detalles del cliente"
                        tooltipOptions={{ position: "top" }}
                        draggable={false}
                    />
                    {/* <div className="text-sm text-color-secondary"> #{item?.id}</div> */}
                    <div className="text-sm text-color-secondary">Prioridad: {item?.prioridad === 0 ? "solicitud más reciente" : item?.prioridad ?? "-"}</div>
                </div>

                <div className="grid mt-2">
                    <div className="col-12 md:col-2">
                        <strong>Estado:</strong>{' '}
                        <span>
                            {(() => {
                                const estadoMeta = mapEstadoToTag(item?.estado);
                                return (
                                    <Tag
                                        value={estadoMeta.label}
                                        severity={estadoMeta.severity || undefined}
                                        style={estadoMeta.style || undefined}
                                    />
                                );
                            })()}
                        </span>
                    </div>
                    <div className="col-12 md:col-2">
                        <strong>Metraje requerido:</strong> <span>{item?.metraje_requerido ?? "-"} m²</span>
                    </div>
                    <div className="col-12 md:col-2">
                        <strong>Empresa:</strong> <span>{item?.empresa?.nombre || "-"}</span>
                    </div>
                    <div className="col-12 md:col-2">
                        <strong>Cotizacion:</strong> <span>{item?.id_cotizacion || "-"}</span>
                    </div>
                </div>

                <div className="grid mt-2">
                    <div className="col-12 md:col-8">
                        <strong>Tipo Producto:</strong> <span>{item?._tiposDescripcion || "-"}</span>
                    </div>
                    <div className="col-12 md:col-8">
                        <strong>Observaciones:</strong> <span>{item?.observaciones || "-"}</span>
                    </div>
                    <div className="col-12 md:col-8">
                        <strong>Prox. producto disponible mayor o igual metraje requerido:</strong>{' '}
                        <span>
                            {(() => {
                                const p = item?.prox_producto_disponible_mayor;
                                if (!p) return 'sin productos disponibles';
                                const fecha =
                                    p.disponible_inmediato
                                        ? 'Inmediato'
                                        : p.fecha_liberacion
                                            ? `Libera: ${new Date(p.fecha_liberacion).toLocaleDateString('es-CL')}`
                                            : '';
                                return [p.tipo_producto, p.nombre, `${p.metraje ?? ''} m²`, fecha]
                                    .filter(Boolean)
                                    .join(' · ');
                            })()}
                        </span>
                    </div>
                    <div className="col-12 md:col-8">
                        <strong>Prox. producto disponible menor metraje requerido:</strong>{' '}
                        <span>
                            {(() => {
                                const p = item?.prox_producto_disponible_menor;
                                if (!p) return 'sin productos disponibles';
                                const fecha =
                                    p.disponible_inmediato
                                        ? 'Inmediato'
                                        : p.fecha_liberacion
                                            ? `Libera: ${new Date(p.fecha_liberacion).toLocaleDateString('es-CL')}`
                                            : '';
                                return [p.tipo_producto, p.nombre, `${p.metraje ?? ''} m²`, fecha]
                                    .filter(Boolean)
                                    .join(' · ');
                            })()}
                        </span>
                    </div>
                    
                </div>

                <div className="flex justify-content-end gap-2 mt-2">
                    <Button
                        icon="pi pi-pencil"
                        className="p-button-rounded p-button-primary p-button-outlined"
                        onPointerDown={(e) => e.stopPropagation()}
                        onMouseDown={(e) => e.stopPropagation()}
                        onDragStart={(e) => { e.preventDefault(); e.stopPropagation(); }}
                        onClick={(e) => { e.stopPropagation(); handleEditListaEspera(item); }}
                        draggable={false}
                        tooltip="Editar solicitud"
                        tooltipOptions={{ position: "top" }}
                        disabled={item?.estado === "CONVERTIDA" || item?.estado === "CANCELADA"}
                    />
                    <Button
                        icon="pi pi-whatsapp"
                        className="p-button-rounded p-button-success p-button-outlined"
                        onPointerDown={(e) => e.stopPropagation()}
                        onMouseDown={(e) => e.stopPropagation()}
                        onDragStart={(e) => { e.preventDefault(); e.stopPropagation(); }}
                        onClick={(e) => { e.stopPropagation(); handleWhatsappListaEspera(item);}}
                        draggable={false}
                        tooltip="Enviar whatsapp"
                        tooltipOptions={{ position: "top" }}
                        disabled={item?.estado === "CONVERTIDA" || item?.estado === "CANCELADA"}
                    />
                    <Button
                        icon="pi pi-times"
                        className="p-button-rounded p-button-danger p-button-outlined"
                        onPointerDown={(e) => e.stopPropagation()}
                        onMouseDown={(e) => e.stopPropagation()}
                        onDragStart={(e) => { e.preventDefault(); e.stopPropagation(); }}
                        onClick={(e) => { e.stopPropagation(); handleDeleteListaEspera(item); }}
                        draggable={false}
                        tooltip="Cancelar solicitud"
                        tooltipOptions={{ position: "top" }}
                        disabled={item?.estado === "CONVERTIDA" || item?.estado === "CANCELADA"}
                    />
                    <Button
                        icon="pi pi-angle-right"
                        className="p-button-rounded p-button-success p-button-outlined"
                        onPointerDown={(e) => e.stopPropagation()}
                        onMouseDown={(e) => e.stopPropagation()}
                        onDragStart={(e) => { e.preventDefault(); e.stopPropagation(); }}
                        onClick={(e) => { e.stopPropagation(); handleConvertListaEspera(item); }}
                        draggable={false}
                        tooltip="ir a cotización"
                        tooltipOptions={{ position: "top" }}
                        disabled={item?.prox_producto_disponible_mayor?.disponible_inmediato === false || 
                        item?.prox_producto_disponible_menor?.disponible_inmediato === false ||
                        item?.estado === "CONVERTIDA" || item?.estado === "CANCELADA"}
                    />
                </div>
            </div>
        );
    };

    return (
        <div>
            {loading ? (
                <Loader />
            ) : (
            <>
                {items.length === 0 ? (
                    <div className="p-3 text-center text-500" style={{ height: '57vh', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        No se encontraron solicitudes
                    </div>
                ) : (
                    <OrderList
                        value={items}
                        onChange={(e) => {
                            setItems(e.value);
                            if (typeof handleReorderPrioridad === 'function') {
                                handleReorderPrioridad(e.value);
                            }
                        }}
                        selection={selectedItems}
                        onSelectionChange={(e) => setSelectedItems(e.value)}
                        metaKeySelection={false}
                        dataKey="id"
                        header={header ? header : `Se encontraron ${items.length} solicitudes`}
                        itemTemplate={itemTemplate}
                        dragdrop={false}
                        controls
                        filter
                        filterBy="_filterText"
                        filterTemplate={filterTemplate}
                        listStyle={{ height: '57vh', width: '100%' }}
                        className="w-full"
                    />
                )}
                <Tooltip target=".p-orderlist-controls .pi-angle-double-up" content="Mover al inicio" position="top" />
                <Tooltip target=".p-orderlist-controls .pi-angle-up" content="Subir prioridad" position="top" />
                <Tooltip target=".p-orderlist-controls .pi-angle-down" content="Bajar prioridad" position="top" />
                <Tooltip target=".p-orderlist-controls .pi-angle-double-down" content="Mover al final" position="top" />
                {showClienteModal && (
                    <ClienteDetalleModal
                        visible={showClienteModal}
                        onHide={closeClienteModal}
                        cliente={clienteSeleccionado}
                    />
                )}
            </>
            )}
        </div>
    );
};

export default OrderTableListaEspera;
